/* global THREE */
import aframe from "aframe";

aframe.registerComponent("game-over-explosion", {
  schema: {
    color: { type: "color", default: "red" },
    growTime: { type: "number", default: 1 },
    fadeTime: { type: "number", default: 1 }
  },
  init: function() {
    this.maxSize = this.el.object3D.scale.x;
    this.el.object3D.scale.set(0.01, 0.01, 0.01);
    this.timer = 0;
    this.burstColour = new THREE.Color();
    this.burstColourTimer = 0;
    randomiseColour(this.burstColour);
  },
  reset: function() {
    this.el.object3D.scale.set(0.01, 0.01, 0.01);
    this.timer = 0;
    this.el.setAttribute("visible", true);
    this.el.components.misound.playSound();
  },
  tick: function(t, dtm) {
    const dt = dtm / 1000;

    this.burstColourTimer += dt;
    if (this.burstColourTimer > 0.05) {
      this.burstColourTimer = 0;
      randomiseColour(this.burstColour);
    }

    this.timer += dt;
    if (this.timer < this.data.growTime) {
      const size = this.timer / this.data.growTime * this.maxSize;
      this.el.object3D.scale.set(size, size, size);
      this.el.setAttribute("explosion-shader", {
        fade: 0,
        color: `#${this.burstColour.getHexString()}`
      });
    } else if (this.timer - this.data.growTime < this.data.fadeTime) {
      const fade = (this.timer - this.data.growTime) / this.data.fadeTime;
      this.el.object3D.scale.set(this.maxSize, this.maxSize, this.maxSize);
      this.el.setAttribute("explosion-shader", {
        fade: fade,
        color: `#${this.burstColour.getHexString()}`
      });
      // this.el.setAttribute("sound", { volume: 1 - fade });
    } else {
      this.el.setAttribute("visible", false);
    }
  }
});

function randomiseColour(c) {
  c.setHSL(Math.random(), 1, Math.random() > 0.6 ? 1 : 0.5);
}
